import { createTable } from 'prosemirror-utils';
import { TextSelection } from 'prosemirror-state';
import { isInTable } from 'prosemirror-tables';
import { toggleMark } from 'prosemirror-commands';
import { setAttr } from '../../utils';
export const insertTable = (state, dispatch) => {
  const tr = state.tr.replaceSelectionWith(createTable(state.config.schema, 3, 3, true));
  if (dispatch) {
    const {
      pos
    } = state.selection.$head;
    tr.setSelection(TextSelection.near(tr.doc.resolve(pos)));
    dispatch(tr);
  }
  return true;
};
export const toggleColorPalette = function (state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    toggleMark(state, dispatch, ...rest);
  }
  return true;
};
export const alignTable = (state, dispatch, alignment) => {
  if (!isInTable(state)) return false;
  let $pos = state.selection.$anchor;
  for (let d = $pos.depth; d > 0; d--) {
    let node = $pos.node(d);
    if (node.type.spec.tableRole === 'table') {
      if (dispatch) dispatch(state.tr.setNodeMarkup($pos.before(d), null, setAttr(node.attrs, alignment, 'alignment')));
      return true;
    }
  }
  return false;
};